import React from "react";
import "./style.scss";
import { InterestedStudiesForm } from "../InterestedStudiesForm";

export const RegistrationForm = (props) => {
    return (
        <div className="registration-form">
            <InterestedStudiesForm values={props?.values}></InterestedStudiesForm>
        </div>
    );
};
